import { createAction } from '@reduxjs/toolkit';

export const getWalletReq = createAction('wallet/getWalletReq');
